import i18next from 'i18next';
import * as yup from 'yup';

const schema = yup.object().shape({
  full_name: yup.string().required(() => i18next.t('validations.required')).trim(),
});

export default schema;
